// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

import ObservationsPage from './components/observations/observations-page.vue'
import ObservationDetails from './components/observations/observation-details.vue'
import storeModule from './store'
import NoctuaSkyClient from './noctuasky-client'

import Signin from './components/users/signin.vue'
import Signup from './components/users/signup.vue'
import PostSignup from './components/users/post-signup.vue'
import MyProfile from './components/users/my-profile.vue'
import ForgotPassword from './components/users/forgot-password.vue'
import UpdateUserInfo from './components/users/update-user-infos.vue'
import ChangePassword from './components/users/change-password.vue'
import ResetPassword from './components/users/reset-password.vue'
import ConfirmEmail from './components/users/confirm-email.vue'

export default {
  vuePlugin: {
    install: (Vue, options) => {
      Vue.component('observations-page', ObservationsPage)
    }
  },
  name: 'noctuaSky',
  storeModule: storeModule,
  panelRoutes: [
    { path: '/p/observations', component: ObservationsPage, meta: { tabName: 'My Observations', prio: 1 } },
    { path: '/p/observations/:id', component: ObservationDetails, props: true },
    { path: 'p/users/signin', component: Signin, meta: { prio: 99 } },
    { path: 'p/users/forgot-password', component: ForgotPassword },
    { path: 'p/users/signup', component: Signup },
    { path: 'p/users/post-signup', component: PostSignup },
    { path: 'p/users/profile', component: MyProfile },
    { path: 'p/users/update-user-infos', component: UpdateUserInfo },
    { path: 'p/users/change-password', component: ChangePassword },
    { path: 'p/users/reset-password/:id', component: ResetPassword, props: true },
    { path: 'p/users/confirm-email/:id', component: ConfirmEmail, props: true }
  ],
  onAppMounted: function (app) {
    // Init NoctuaSkyClient
    const onNoctuaSkyStateChanged = function (path, value) {
      app.$store.commit('noctuaSky/modifyNoctuaSkyState', { path: path, newValue: value })
    }
    NoctuaSkyClient.init(process.env.VUE_APP_NOCTUASKY_API_SERVER, onNoctuaSkyStateChanged)
  }
}
